"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestrasEspecialidades() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const whiskeys = [{
    region: "MEDICINA CAPILAR",
    name: "Pérdida de Densidad",
    age: "El cabello se vuelve más fino y pierde volumen\xA0",
    notes: ["BIOESTIMULACIÓN", "NUTRICIÓN", "VITALIDAD"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-3.png?v=b8s5y35vrcs",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web.png?v=pm9xys7yu9-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web.png?v=yj55bkejbop-wvc-sizes"
  }, {
    region: "MEDICINA CAPILAR",
    name: "Cabello débil",
    age: "Pelo frágil, sin cuerpo ni vitalidad",
    notes: ["ANCLAJE", "GROSOR", "RESISTENCIA"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-1.png?v=yd2ayeskll",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-1.png?v=7d6m6vjf8vy-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-1.png?v=7x30pj0k5kv-wvc-sizes"
  }, {
    region: "MEDICINA CAPILAR",
    name: "Caída de cabello",
    age: "Pérdida de pelo que afecta a tu día a día",
    notes: ["PREVENCIÓN", "EQUILIBRIO", "SALUD"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px.png?v=cybgn85yeih",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px.png?v=c15psesxjck-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px.png?v=9x13tp5hq6-wvc-sizes"
  }, {
    region: "CIRUGÍA CAPILAR",
    name: "Entradas\xA0",
    age: "La línea frontal retrocede y cambia tu imagen",
    notes: ["NATURALIDAD", "SIN CICATRIZ", "DENSIDAD"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-4.png?v=hle0rvbsv4",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-4.png?v=l56gr83tkap-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-4.png?v=lp12ifg8t8-wvc-sizes"
  }, {
    region: "CIRUGÍA CAPILAR",
    name: "Alopecia avanzada",
    age: "Zonas sin cabello que requieren solución\xA0",
    notes: ["ARMONÍA", "FACIAL", "NATURAL"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-5.png?v=2c0kiybdwnf",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-5.png?v=ectjqw43egg-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-5.png?v=6eeadjuik35-wvc-sizes"
  }, {
    region: "CIRUGÍA CAPILAR",
    name: "Reconstrucción de línea frontal",
    age: "Recupera el marco natural de tu rostro",
    notes: ["PRECISIÓN", "FORMA", "EXPRESIÓN"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-6.png?v=9eoadye3j9g",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-6.png?v=qo2y82bn1zh-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-6.png?v=wve7b9swhi9-wvc-sizes"
  }, {
    region: "CIRUGIA CAPILAR",
    name: "Injerto capilar",
    age: "Solución permanente y de resultado natural para la pérdida severa",
    notes: ["TRICOLOGÍA", "ANÁLISIS", "PLAN"],
    price: "GRATIS",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-7.png?v=b0ierem0p6",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-7.png?v=v5g6uilvmdn-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-7.png?v=65deexci2sb-wvc-sizes"
  }, {
    region: "CIRUGIA CAPILAR",
    name: "Alternativas al Injerto",
    age: "Tratamientos médicos para frenar y revertir la caída sin cirugía",
    notes: ["EVOLUCIÓN", "RESULTADOS", "CUIDADO"],
    price: "INCLUIDO",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-8.png?v=xrafroq2qj",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-8.png?v=p5oar1vx7m-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-8.png?v=5pc1n00bf98-wvc-sizes"
  }, {
    region: "CIRUGIA CAPILAR",
    name: "Reconstrucción de cejas",
    age: "Diseño y densificación de cejas para un resultado armónico y natural",
    notes: ["BIENESTAR", "SALUD", "CALIDAD"],
    price: "CONSULTAR",
    image: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-9.png?v=sraxtmpf3a",
    srcset: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-9.png?v=46epch70ctq-wvc-srcset",
    sizes: "https://msinstitutocapilar.com/wp-content/uploads/2026/07/imagenes-problemas-web-216-x-271-px-9.png?v=1qdqmsctasi-wvc-sizes"
  }];
  return <section data-section-id="2747" id="nuestras-especialidades" className="text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden light bg-muted">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs tracking-[0.3em] mb-8 text-primary"><span className="!font-bold">NUESTRAS&nbsp; ESPECIALIDADES</span></p>
          <h2 className="font-default font-medium leading-[1.1] max-w-3xl mx-auto !text-[50px]">Cada problema capilar tiene un abordaje diferente</h2>
        </div>

        <div ref={gridRef} className={`mt-20 md:mt-24 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {whiskeys.map((whiskey, i) => <Card key={i} data-index={i} className="group bg-card p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border">
              <div className="relative overflow-hidden mb-8" style={{
            aspectRatio: "4 / 5",
            background: "var(--accent)"
          }}>
                <img src={whiskey.image} data-wvc-srcset={whiskey.srcset} data-wvc-sizes={whiskey.sizes} alt={whiskey.name} loading="lazy" decoding="async" className="relative w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
              </div>

              <CardContent className="px-0">
                <p className="font-default text-[10px] tracking-[0.25em] mb-4 text-primary !font-bold">
                  {whiskey.region}
                </p>
                <h3 className="font-default text-2xl md:text-[1.75rem] font-medium leading-tight mb-2">
                  {whiskey.name}
                </h3>
                <p className="font-default text-base mb-6 text-muted-foreground">
                  {whiskey.age}
                </p>

                <div className="h-px w-full mb-6 bg-primary/30" />

                

                <div className="flex items-center justify-end">
                  
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div ref={ctaRef} className={`mt-20 md:mt-24 text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild variant="link" className="group font-default text-xs tracking-[0.3em] p-0 h-auto hover:no-underline text-primary">
            <Link className="relative inline-block !font-bold underline cursor-pointer" href="https://msinstitutocapilar.com/contacto/" newTab>
              <span>
                SOLICITAR CONSULTA GRATUITA
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0 bg-primary" />
                <span className="absolute left-0 -bottom-1 h-px w-full origin-right scale-x-0 transition-transform duration-500 delay-150 group-hover:scale-x-100 bg-primary" />
              </span>
              <ArrowRight className="ml-2 size-3 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}